import useSWR, {SWRConfiguration} from "swr";
import {apiEndpoints} from "@/utils/api-endpoints";
import {fetcher} from "@/lib/swr-config";
import Faq from "@/types/faq";


export function useFaqs(options?: SWRConfiguration<Faq[]>) {
    const {url} = apiEndpoints.Faq.GetAll;
    return useSWR<Faq[]>(url, fetcher, {
        ...options,
    });
}
